export enum BookingType {
    NORMAL = "NORMAL",
    BRUGES = "BRUGES",
    HIGH_SCHOOL = "HIGH_SCHOOL",
    IMMERSION = "IMMERSION"
}
